import * as React from "react";
import { LinkSingle } from "../LinkSingle";

export interface MijnFNVViewPageBlockProps {
  title: string;
  subtitle?: string;
  url: string;
}

export function MijnFNVViewPageBlock(props: MijnFNVViewPageBlockProps) {
  return (
    <>
      <LinkSingle
        title={props.title}
        subtitle={props.subtitle}
        to={props.url}
      />
    </>
  );
}
